import { Text } from '@dixa/lib-shared-habla';
import { MetaConversation } from 'lib-shared-legacy-types';
import { Fragment } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'react-router-dom';

import styles from '../conversationDetails.module.scss';
import { ConversationDetailsLayout } from '../conversationDetailsLayout';
import { getConversationTitle } from '../helpers';

type PropsT = {
  className?: string;
  conversationUrl?: string;
  metaConversation: MetaConversation;
  layout: ConversationDetailsLayout;
  linkToConversation?: boolean;
};

export const Title = ({
  conversationUrl,
  metaConversation,
  layout,
  linkToConversation,
}: PropsT): JSX.Element => {
  const titleStrings = getConversationTitle(metaConversation);
  const { requester, subject } = titleStrings;

  const isSidebarLayout =
    layout === ConversationDetailsLayout.Sidebar ||
    layout === ConversationDetailsLayout.SidebarCollapsed;

  const title = (
    <Fragment>
      {requester}
      {!isSidebarLayout && subject && (
        <Text.Paragraph as="span" variant="1" subdued>
          {` - ${subject}`}
        </Text.Paragraph>
      )}
    </Fragment>
  );

  if (conversationUrl) {
    return linkToConversation ? (
      <Link to={conversationUrl} className={styles.titleLink}>
        {title}
      </Link>
    ) : (
      <span>{title}</span>
    );
  }

  return title;
};
